import { createContext } from 'react';

const MenuNavigationContext = createContext<((link: string) => void) | undefined>(undefined);

export { MenuNavigationContext };
